import NewTransferModal from "./NewTransferModal";

interface FgtsModalProps {
  onBack: () => void;
}

export default function FgtsModal({ onBack }: FgtsModalProps) {
  return <NewTransferModal onBack={onBack} />;
}
